const sealink_nt = {
  id: 'sealink_nt',
  name: 'SeaLink NT',
  quicktravelUrl: 'https://nt-training.quicktravel.com.au',
  productTypeIDs: [30, 31], // 30=NT Ferry & Bus 31=NT Kiosk
  adjustmentCategoryId: 13, // ID of category of adjustments to show
  payments: {
    allowedPaymentTypes: [
      { id: 1, code: 'cash' },
      { id: 6, code: 'eftpos' },
      { id: 7, code: 'cheque' },
      { id: 9, code: 'amex' },
      { id: 13, code: 'on_account' },
      { id: 19, code: 'mastercard_visa' },
    ],
    defaultPaymentTypeId: 1,
  },
  countries: {
    required: true,
    promotedCountries: [14, 74, 81, 232, 158],
    requiringPostcode: [14],
  },
  printing: {
    host: 'https://printers-next.quicktravel.com.au',
    catalogueId: 1,
  },
  receipts: {
    autoPrint: false,
    printType: 'quickets',
  },
  apiKey: '652eb27f141c34601294e2071ddb9aef99745fa356e14f18d62f8591cdb283a9',
};

const sealink_nq = {
  id: 'sealink_nq',
  name: 'SeaLink NQ',
  quicktravelUrl: 'https://nq-training.quicktravel.com.au',
  productTypeIDs: [26, 27, 16, 29], // 26=magnetic, 27=palm, 16=merchandise, 29=car parking
  adjustmentCategoryId: 1, // ID of category of adjustments to show
  payments: {
    allowedPaymentTypes: [
      { id: 1, code: 'cash' },
      { id: 5, code: 'tcc_voucher' },
      { id: 6, code: 'eftpos' },
      { id: 7, code: 'cheque' },
      { id: 9, code: 'amex' },
      { id: 13, code: 'on_account' },
      { id: 19, code: 'mastercard_visa' },
      { id: 48, code: 'tsv' },
    ],
    defaultPaymentTypeId: 1,
  },
  countries: {
    required: true,
    promotedCountries: [14, 74, 81, 232, 158],
    requiringPostcode: [14],
  },
  printing: {
    host: 'https://printers-next.quicktravel.com.au',
    catalogueId: 7,
  },
  receipts: {
    autoPrint: false,
    printType: 'quickets',
  },
  apiKey: '652eb27f141c34601294e2071ddb9aef99745fa356e14f18d62f8591cdb283a9',
};

const captain_cook = {
  id: 'captain_cook',
  name: 'Captain Cook NSW',
  quicktravelUrl: 'https://cc-training.quicktravel.com.au',
  productTypeIDs: [10, 17, 14],
  payments: {
    allowedPaymentTypes: [
      { id: 1, code: 'cash' },
      { id: 4, code: 'on_account' },
      { id: 8, code: 'amex' },
      { id: 11, code: 'mastercard_visa' },
      { id: 13, code: 'on_account' },
      { id: 17, code: 'diners' },
      { id: 18, code: 'jcb' },
      { id: 20, code: 'eftpos' },
    ],
    defaultPaymentTypeId: 1,
  },
  countries: {
    required: true,
    promotedCountries: [14],
    requiringPostcode: [14],
  },
  printing: {
    host: 'https://printers-next.quicktravel.com.au',
    catalogueId: 3,
  },
  apiKey: '35a81a2809824bed661ae9914ffb0c3af59ca3085ce5d322694f9a79d263d2eb',
};

const stradbroke = {
  id: 'stradbroke',
  name: 'SeaLink SEQ',
  quicktravelUrl: 'https://stradbroke-training.quicktravel.com.au',
  productTypeIDs: [5, 8, 15, 16],
  payments: {
    allowedPaymentTypes: [
      { id: 1, code: 'cash' },
      { id: 3, code: 'on_account' },
      { id: 6, code: 'on_account_ref' },
      { id: 8, code: 'mastercard_visa' },
      { id: 26, code: 'eftpos_debit' },
      { id: 12, code: 'eftpos_mastercard' },
      { id: 13, code: 'eftpos_visa' },
      { id: 10, code: 'eftpos_amex' },
    ],
    defaultPaymentTypeId: 1,
  },
  countries: {
    required: true,
    promotedCountries: [14],
    requiringPostcode: [14],
  },
  printing: {
    host: 'https://printers-next.quicktravel.com.au',
    catalogueId: 5,
  },
  apiKey: 'fa6e7f44b52dae2b14c801b16556606fb1c4176528e7c1901ecbba41d21d898b',
};

const bruny = {
  id: 'bruny',
  name: 'SeaLink Bruny Island',
  quicktravelUrl: 'https://bruny-training.quicktravel.com.au',
  productTypeIDs: [3],
  payments: {
    allowedPaymentTypes: [
      { id: 1, code: 'cash' },
      { id: 3, code: 'on_account' },
      { id: 4, code: 'on_account_ref' },
      { id: 7, code: 'cheque' },
      { id: 24, code: 'eftpos_mastercard_visa' },
    ],
    defaultPaymentTypeId: 25,
  },
  adjustmentCategoryId: 7,
  categoryColourConfig: {
    2: {
      activeBackground: 'darkblue',
      activeFont: 'white',
      background: 'darkblue',
      font: 'white',
    },
    3: {
      activeBackground: 'lightblue',
      activeFont: 'black',
      background: 'lightblue',
      font: 'black',
    },
    4: {
      activeBackground: '#3D8D3D',
      activeFont: 'black',
      background: '#3D8D3D',
      font: 'black',
    },
    5: {
      activeBackground: 'yellow',
      activeFont: 'black',
      background: 'yellow',
      font: 'black',
    },
  },
  autoPromoCode: {
    mode: 'seasonality',
    seasonalities: {
      departureMode: 'next',
      departure: {
        route_id: 1,
        from_stop_id: 1,
      },
      mapping: {
        1: { id: 4, code: 'LIGHTFARES (SUPERSAVER)' },
        2: { id: 13, code: 'SAVER' },
      },
    },
  },
  countries: {
    required: false,
    promotedCountries: [14],
    requiringPostcode: [14],
  },
  autoValidateTicket: true,
  printing: {
    host: 'https://printers-next.quicktravel.com.au',
    catalogueId: 8,
  },
  receipts: {
    autoPrint: true,
    printType: 'albert',
  },
  apiKey: 'a174b6c146bcfd2c8d93902e0253fec4ca6cdafbd9f54b7eaad9921d4f74d501',
};

const cc_wa = {
  id: 'captain_cook_wa',
  name: 'SeaLink WA',
  quicktravelUrl: 'https://ccwa-training.quicktravel.com.au',
  productTypeIDs: [23, 24, 28],
  payments: {
    allowedPaymentTypes: [{ id: 1, code: 'cash' }],
    defaultPaymentTypeId: 1,
  },
  countries: {
    required: false,
    promotedCountries: [14],
    requiringPostcode: [14],
  },
  categoryColourConfig: {
    2: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'darkblue',
      font: 'white',
    },
    3: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'lightblue',
      font: 'black',
    },
    4: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'green',
      font: 'black',
    },
    5: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'yellow',
      font: 'black',
    },
  },
  adjustmentCategoryId: 16,
  autoPromoCodes: [],
  autoValidateTicket: false,
  printing: {
    host: 'https://printers-next.quicktravel.com.au',
    catalogueId: 4,
  },
  receipts: {
    autoPrint: true,
    printType: 'quickets',
  },
  apiKey: '9def3c493e3d0aac8ee08e5eae0753b070bf99d5b9f6b35e0c65a3fb04628da9',
};

const wa_experiences = {
  id: 'wa_experiences',
  name: 'WA Experiences',
  quicktravelUrl: 'https://wa-experiences-training.quicktravel.com.au',
  productTypeIDs: [23, 24, 28],
  payments: {
    allowedPaymentTypes: [{ id: 1, code: 'cash' }],
    defaultPaymentTypeId: 1,
  },
  countries: {
    required: false,
    promotedCountries: [14],
    requiringPostcode: [14],
  },
  categoryColourConfig: {
    2: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'darkblue',
      font: 'white',
    },
    3: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'lightblue',
      font: 'black',
    },
    4: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'green',
      font: 'black',
    },
    5: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'yellow',
      font: 'black',
    },
  },
  adjustmentCategoryId: 16,
  autoPromoCodes: [],
  autoValidateTicket: false,
  printing: {
    host: 'https://printers-next.quicktravel.com.au',
    catalogueId: 4,
  },
  receipts: {
    autoPrint: true,
    printType: 'quickets',
  },
  apiKey: '9def3c493e3d0aac8ee08e5eae0753b070bf99d5b9f6b35e0c65a3fb04628da9',
};

const sealink_sa = {
  id: 'sealink',
  name: 'SeaLink SA',
  quicktravelUrl: 'https://kis-training.quicktravel.com.au',
  productTypeIDs: [554881950, 554881979],
  payments: {
    allowedPaymentTypes: [{ id: 1, code: 'cash' }],
    defaultPaymentTypeId: 1,
  },
  countries: {
    required: false,
    promotedCountries: [14],
    requiringPostcode: [14],
  },
  categoryColourConfig: {
    2: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'darkblue',
      font: 'white',
    },
    3: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'lightblue',
      font: 'black',
    },
    4: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'green',
      font: 'black',
    },
    5: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'yellow',
      font: 'black',
    },
  },
  adjustmentCategoryId: 750275996,
  autoPromoCodes: [],
  autoValidateTicket: false,
  printing: {
    host: 'https://printers-next.quicktravel.com.au',
    catalogueId: 2,
  },
  receipts: {
    autoPrint: false,
    printType: 'quickets',
  },
  apiKey: 'ed50492595b8528aa2b7c575959ad385eab56ca8f6ac8dcabc9fcb0f5eceab27',
};

const kis_tourism = {
  id: 'kis_tourism',
  name: 'KIS Tourism',
  quicktravelUrl: 'https://kis-tourism-training.quicktravel.com.au',
  productTypeIDs: [554881950, 554881979],
  payments: {
    allowedPaymentTypes: [{ id: 1, code: 'cash' }],
    defaultPaymentTypeId: 1,
  },
  countries: {
    required: false,
    promotedCountries: [14],
    requiringPostcode: [14],
  },
  categoryColourConfig: {
    2: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'darkblue',
      font: 'white',
    },
    3: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'lightblue',
      font: 'black',
    },
    4: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'green',
      font: 'black',
    },
    5: {
      activeBackground: 'white',
      activeFont: 'black',
      background: 'yellow',
      font: 'black',
    },
  },
  adjustmentCategoryId: 750275996,
  autoPromoCodes: [],
  autoValidateTicket: false,
  printing: {
    host: 'https://printers-next.quicktravel.com.au',
    catalogueId: 2,
  },
  receipts: {
    autoPrint: false,
    printType: 'quickets',
  },
  apiKey: 'ed50492595b8528aa2b7c575959ad385eab56ca8f6ac8dcabc9fcb0f5eceab27',
};

export default {
  tenants: [
    sealink_nt,
    sealink_nq,
    captain_cook,
    stradbroke,
    bruny,
    cc_wa,
    wa_experiences,
    sealink_sa,
    kis_tourism,
  ],
  printingEnabled: true,
  debugEvents: false,
  rollbar: {
    accessToken: '244053c716364af1a39217cb3cafae96',
    environment: 'production',
    enabled: true,
  },
  datadog: {
    applicationId: 'ac90443c-2836-4ed2-8a7e-9a0dad22c441',
    clientToken: 'pubfaeb9fcfacb936e85c3ef987ef0b5411',
    environment: 'prod',
    service: 'quicktickets-web-edge',
  },
  gitSha: null,
  showEnv: false,
  authServiceURL: 'https://auth-next.quicktravel.com.au',
  guestLinkURL: 'https://guestlink.quicktravel.com.au',
  oktaIssuer: 'https://kelsian.okta.com/oauth2/aus2r719unt8dKcPH697',
  oktaClientId: '0oa4d14k3aFzJvBcV697',
  oktaAppBase: 'https://quicktickets-web-edge.quicktravel.com.au',
  oktaEnabled: true,
  googleTagManagerId: 'G-HHRP10DTK2',
};
